import { createLookup, isUndefinedOrNull } from "../omnia"
import { INtrReq, INutritionPlan, IRequirementsProvider } from "../types"
import { sortPlansByCalcOrder } from "../utils"

export function createRequirementsProvider(requirements: INtrReq[], plans: INutritionPlan[]): IRequirementsProvider {

    const requirementsLookup = createLookup(requirements || [], r => r.CroppingId)

    plans = sortPlansByCalcOrder(plans || [], p => p)

    return {

        getRequirements,

        getInitialRequirements,
        getClosingRequirements,

        getCroppingInitialRequirements,
        getCroppingClosingRequirements,

        getPlanRequirements,
        getPlanClosingRequirements,

        getOrderedRequirementZones

    }

    ///

    function getRequirements(croppingId: number): INtrReq[] {
        return requirementsLookup[croppingId] || [];
    }

    function getInitialRequirements(croppingId: number, zones?: boolean): INtrReq[] {
        return filterZones(
            getRequirements(croppingId).filter(r => (!r.PlanId) && (!r.Aggregate)),
            zones
        );
    }

    function getCroppingInitialRequirements(croppingId: number): INtrReq {
        return getRequirements(croppingId).find(r => (!r.PlanId) && (!r.Zone));
    }

    function filterZones(req: INtrReq[], zones?: boolean): INtrReq[] {
        if (isUndefinedOrNull(zones)) return req;
        return req.filter(r => (!!r.Zone) == (!!zones));
    }

    function getPlanRequirements(croppingId: number, planId: number): INtrReq[] {

        let requirements = getRequirements(croppingId);

        let closing = requirements.filter(r => !r.PlanId);

        for (let p of plans) {

            if (p.NutritionPlanId == planId) {
                break;
            }

            let closingReq = requirements.filter(r => r.PlanId == p.NutritionPlanId);

            if (closingReq.length) {
                closing = closingReq;
            }

        }

        return closing;

    }

    function getPlanClosingRequirements(croppingId: number, planId: number): INtrReq[] {

        var plan = plans.find(p => p.NutritionPlanId === planId);
        var planIndex = plans.indexOf(plan);
        var nextPlan = planIndex < (plans.length - 1) ? plans[planIndex + 1] : null;

        return getPlanRequirements(croppingId, nextPlan ? nextPlan.NutritionPlanId : 0);
    }

    function getClosingRequirements(croppingId: number, zones?: boolean): INtrReq[] {
        return filterZones(
            getPlanRequirements(croppingId, 0),
            zones
        );
    }

    function getCroppingClosingRequirements(croppingId: number): INtrReq {
        const closing = getPlanRequirements(croppingId, 0);
        return closing.find(b => !b.Zone);
    }

    /**
     * Returns all requirement zones, both opening and closing, and grouped by cropping
     * For each cropping, the "plans" array always starts with the opening requirements (before any application),
     * then lists all plans in application order
     */
    function getOrderedRequirementZones(): { croppingId: number, plans: { planId: number, zones: INtrReq[] }[] }[] {

        let planIds = [0].concat(plans.map(p => p.NutritionPlanId));

        let zones = Object.keys(requirementsLookup).map(k => Number(k)).map(croppingId => {

            let croppingZones = requirementsLookup[croppingId];

            let plans = planIds.map(planId => {

                let planZones = croppingZones.filter(z => (z.PlanId || 0) == planId);
                return planZones.length ? { planId: planId, zones: planZones } : null;

            }).filter(r => !!r);

            return {
                croppingId: croppingId,
                plans: plans
            };

        });

        return zones;

    }

}
